// 附件预览渲染器的按需装配
// 注意: 本模块只能包含动态 import, 不允许静态引用 @file-viewer/* 的重包,
// 否则渲染器会被拖进首屏 chunk

const loaders = {
  pdf: () => import('@file-viewer/renderer-pdf').then((m) => m.pdfRenderer),
  word: () => import('@file-viewer/renderer-word').then((m) => m.wordRenderer),
  sheet: () => import('@file-viewer/renderer-spreadsheet').then((m) => m.spreadsheetRenderer),
  slides: () => import('@file-viewer/renderer-presentation').then((m) => m.presentationRenderer),
}

// 浏览器内置基线即可预览的类型, 不额外加载渲染器
const builtinExtensions = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg', 'ico', 'txt', 'log', 'md', 'json', 'xml', 'html', 'htm', 'mp3', 'wav', 'm4a', 'ogg', 'mp4', 'webm', 'mov']

const rendererByExtension = {
  pdf: 'pdf',
  doc: 'word',
  docx: 'word',
  dot: 'word',
  dotx: 'word',
  rtf: 'word',
  odt: 'word',
  wps: 'word',
  xls: 'sheet',
  xlsx: 'sheet',
  xlsm: 'sheet',
  xlsb: 'sheet',
  csv: 'sheet',
  ods: 'sheet',
  et: 'sheet',
  ett: 'sheet',
  ppt: 'slides',
  pptx: 'slides',
  pps: 'slides',
  ppsx: 'slides',
  pot: 'slides',
  potx: 'slides',
  odp: 'slides',
  dps: 'slides',
  dpt: 'slides',
}

export const getExtension = (name) => {
  const clean = (name || '').split(/[?#]/)[0]
  const index = clean.lastIndexOf('.')
  return index === -1 ? '' : clean.slice(index + 1).toLowerCase()
}

// 该文件需要动态加载的渲染器
const resolveRendererKeys = (name) => {
  const extension = getExtension(name)
  if (!extension || builtinExtensions.includes(extension)) return []
  const key = rendererByExtension[extension]
  return key ? [key] : []
}

export const loadRenderers = (name) => Promise.all(resolveRendererKeys(name).map((key) => loaders[key]()))

// 预取: 提前把该类型的渲染器拉下来, 让点击预览更快
export const prefetchRenderers = (name) => {
  resolveRendererKeys(name).forEach((key) => {
    loaders[key]().catch(() => {})
  })
}
